import { JsonRpcApiProvider, JsonRpcProvider, JsonRpcSigner } from 'ethers';

import { OnChainToken } from 'config/configType';
import { getCurrentStateChainConfig } from 'config/configUtils';

type Chain = {
  chainRpc: string;
  chainId: number;
  chainNetwork: string;
};

const getAnonymousWalletProviderForChain = (chain: Chain) => {
  return new JsonRpcProvider(chain.chainRpc, {
    chainId: chain.chainId,
    name: chain.chainNetwork,
  });
};

/** Anonymous wallet provider without knowledge of user wallet (no caller) */
export const getAnonymousRPCProvider = (
  overrideChain?: Chain
): JsonRpcProvider => {
  return getAnonymousWalletProviderForChain(
    overrideChain ?? getCurrentStateChainConfig()
  );
};

/** For many actions it's required for RPC provider to have Wallet available (caller wallet) */
export const getUncheckedWalletRPCProvider = (
  walletAddress: string,
  overrideChain?: Chain
): JsonRpcSigner => {
  const chain = getCurrentStateChainConfig();
  return new JsonRpcSigner(
    getAnonymousWalletProviderForChain(overrideChain ?? chain),
    walletAddress
  );
};

// export const getAnonymousWalletProvider = (
//   overrideChain?: Chain
// ): JsonRpcProvider => {
//   const chain = getCurrentStateChainConfig();
//   return getAnonymousWalletProviderForChain(overrideChain ?? chain);
// };

/**
 * Watch asset in Software Wallet - will trigger popup
 * To watch USDC use `USDCTokenOnKatanaEVM` as parameter.
 */
export const watchAssetInSoftwareWallet = (
  provider: JsonRpcProvider | JsonRpcApiProvider,
  token: OnChainToken
) => {
  return provider.send('wallet_watchAsset', {
    type: 'ERC20',
    options: {
      address: token.contractAddress,
      symbol: token.symbol,
      decimals: token.assetDecimals,
      // image: tokenImage
    },
  });
};
